export const exportChallengesCSV = (challenges: Challenge[], eventName?: string) => {
  const csvHeaders = ["ID", "Type", "Title", "About", "Copy", "Points", "Hidden"];

  const csvRows = challenges.map((challenge) => {
    const row = [
      challenge.id,
      challenge.type,
      challenge.title || challenge.title_en || challenge.title_lt || "",
      challenge.about || challenge.about_en || challenge.about_lt || "",
      challenge.copy || challenge.copy_en || challenge.copy_lt || "",
      challenge.points?.toString() || "0",
      challenge.hidden ? "Yes" : "No",
    ];

    return row
      .map((field) => {
        const escaped = field.replace(/"/g, '""');
        return `"${escaped}"`;
      })
      .join(",");
  });

  const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  const timestamp = new Date().toISOString().split("T")[0];
  const fileName = eventName ? `challenges_${eventName}_${timestamp}.csv` : `challenges_${timestamp}.csv`;

  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
